import { Helmet } from 'react-helmet-async'
import BastionCalc from '../components/calculators/BastionCalc'
import { generateBreadcrumbList } from '../utils/schemaHelpers'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'

export default function BastionPage() {
  return (
    <div className="px-6 py-6 w-full">
      <Helmet>
        <title>Azure Bastion Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Calculate Azure Bastion costs for UK South. Compare Basic, Standard, and Premium tiers with scaling units in GBP. Bastion bills 24/7 — understand the always-on cost before deploying." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/bastion" />
        <meta property="og:title" content="Azure Bastion Calculator UK" />
        <meta property="og:description" content="Free independent Azure Bastion pricing for UK South. All tiers with scaling units in GBP. Includes always-on billing trap warnings." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/bastion" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'HowTo',
          name: 'How to estimate Azure Bastion costs for UK South',
          description: 'Use AzureCalc.uk to estimate monthly Azure Bastion costs in GBP.',
          step: [
            { '@type': 'HowToStep', position: 1, name: 'Select a tier', text: 'Choose Basic (fixed 2 units), Standard (custom scaling + native client), or Premium (session recording + private-only deployment).' },
            { '@type': 'HowToStep', position: 2, name: 'Set scaling units', text: 'Standard and Premium tiers scale from 2 to 50 units. Each unit supports ~25 concurrent sessions.' },
            { '@type': 'HowToStep', position: 3, name: 'Enter outbound data', text: 'Inbound RDP/SSH traffic is free. Only outbound from Azure is billed.' },
            { '@type': 'HowToStep', position: 4, name: 'Review the cost', text: 'The calculator shows the monthly estimate, per-day cost, and a tier comparison table.' },
          ],
        })}</script>
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Bastion Calculator', url: '/bastion', position: 2 },
        ]))}</script>
      </Helmet>

      <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
        <Breadcrumbs />
        <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>Azure Bastion Cost Calculator</h1>
        <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>UK South pricing · Basic, Standard &amp; Premium tiers · Scaling units · Always-on billing</p>
      </div>

      <BastionCalc />
    </div>
  )
}
